const state = {
    pickershow: false,
    userpicker: false,
    spicker: 0,
    customlayer: [],
    locallayer: [],
    useritem: null,
    tableData: [
    ],
}
const getters = {
    pickershow(state) {
        return state.pickershow
    },
    userpicker(state) {
        return state.userpicker
    },
    spicker(state) {
        return state.spicker
    },
    customlayer(state) {
        return state.customlayer
    },
    locallayer(state) {
        return state.locallayer
    },
    useritem(state) {
        return state.useritem
    },
    tableData(state) {
        return state.tableData
    },



}
const mutations = {
    changepickershow(state, pickershow) {
        state.pickershow = pickershow
    },
    changeuserpicker(state, userpicker) {
        state.userpicker = userpicker
    },
    changespicker(state, spicker) {
        state.spicker = spicker
    },
    changecustomlayer(state, customlayer) {
        state.customlayer = customlayer
    },
    changelocallayer(state, locallayer) {
        state.locallayer = locallayer
    },
    changeuseritem(state, useritem) {
        state.useritem = useritem
    },
    changetableData(state, tableData) {
        console.log(tableData);
        state.tableData = tableData
    },

}
const actions = {
    changepickershow({
        commit
    }, bool) {
        commit('changepickershow', bool)
    },
    changeuserpicker({
        commit
    }, bool) {
        commit('changeuserpicker', bool)
    },
    changespicker({
        commit
    }, bool) {
        commit('changespicker', bool)
    },
    changecustomlayer({
        commit
    }, bool) {
        commit('changecustomlayer', bool)
    },
    changelocallayer({
        commit
    }, bool) {
        commit('changelocallayer', bool)
    },
    changeuseritem({
        commit
    }, bool) {
        commit('changeuseritem', bool)
    },
    changetableData({
        commit
    }, bool) {
        commit('changetableData', bool)
    },

}
export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}